// extracted by mini-css-extract-plugin
module.exports = {"Contacts":"Contacts_Contacts__1kGpG","Contacts__Cols":"Contacts_Contacts__Cols__lrEVT","Contacts__Col":"Contacts_Contacts__Col__3mFVm"};